import { render, staticRenderFns } from "./mailAdd.vue?vue&type=template&id=2924313d&scoped=true&"
import script from "./mailAdd.vue?vue&type=script&lang=js&"
export * from "./mailAdd.vue?vue&type=script&lang=js&"
import style0 from "./mailAdd.vue?vue&type=style&index=0&id=2924313d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2924313d",
  null
  
)

export default component.exports